import React from "react";
import { Route, Routes, useParams } from "react-router-dom";
import VerifyTwoPlusSacc from "./verifyTwoPlusSacc";
import Decline from "./decline";
import { VERIFY_STEPS } from "../../../constants/commonConstants";


const stepRoutes = [
  {
    path: VERIFY_STEPS.twoPlusSacc.path,
    exact: false,
    component: VerifyTwoPlusSacc,
    meta: {...VERIFY_STEPS.twoPlusSacc},
  },
  {
    path: VERIFY_STEPS.decline.path,
    exact: false,
    component: Decline,
    meta: {...VERIFY_STEPS.decline},
  },
];

const VerifyRouter = () => {
//   const match = useMatch('/your/path');
// if (match) {
//     const path = match.pathname; // This gives you the matched pathname
// }
  let { path } = useParams();
  
  return (
    <main>
      <Routes>
        {stepRoutes.map((route, index) => (
          <Route path={route.path} exact={route.exact} key={index}
            element={<route.component meta={route.meta}/>} meta={route.meta}  />
        ))}
      </Routes>
    </main>
  );
};

export default VerifyRouter;